import axios from 'axios';

export const storageFileApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/storage-file`,
    headers: {
        'Content-Type': 'application/json'
    }
})